import { NavigationLink } from "components/base/base";

export const LeftButtons = () => {
  return (
    <div className="flex space-x-4">
      <NavigationLink to="/stock/china" title="China" />
      <NavigationLink to="/stock/supplier" title="Suppliers" />
      <NavigationLink to="/stock/china-v2" title="China V2" />
      <NavigationLink to="/stock/alc/2B" title="ALC(2B)" />
      <NavigationLink to="/stock/alc/2C" title="ALC(2C)" />
      <NavigationLink to="/stock/charles-kendall" title="Charles Kendall" />
      <NavigationLink to="/stock/fsi" title="INC FSI" />
    </div>
  );
};

export const RightButtons = () => (
  <div className="flex">
    <NavigationLink to="/stock/odoo/search" title="Import from Odoo" />
  </div>
);
